import product from './product.js';

export default (cart) => ({
	event: 'cartOpen',
	cartLocale: cart.url.locale,
	cartPlatform: cart.theme.tracking.platform,
	cartProvider: cart.theme.provider.name,
	cartFlow: cart.order.flow,
	loginStatus: cart.order.loginStatus,
	metric3: 1, // Custom metric - opening cart
	pageName: cart.page.tracking,
	testOrder: cart.order.isTest,
	ecommerce: {
		currencyCode: cart.order.currency,
		impressions: [],
		add: {
			products: cart.order.products.map(product), // Create an array of products
			actionField: {
				affiliation: cart.url.hostname
			}
		}
	},
	orderId: cart.order.id,
	contentGroup: cart.order.contentGroup,
	server: {
		dataCenter: cart.app.session.origin
	}
});
